import { useState,useEffect } from "react";
import http from "../utils/http";
import uri from "../utils/uri";

const useItems = ({open = true, exists=false, active=false}) => {
    
    const [ isLoading, setIsLoading] = useState(true);
    const [ items, setItems] = useState([]);   

    const callApi = async () => {

        const data = await http(uri.items.asCatalog).asGet();        

        setItems(data);
        setIsLoading(false);

    }
    
    useEffect(() => {
        callApi();
    }, [open]);

    return {
        items, 
        setItems,
        isLoading
    }

}

export default useItems;